import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {QuoteState} from '../../model/quote';
import {QuoteBarItem} from '../../model/quote-bar-item';
import {AbstractQuoteComponent} from '../abstract-quote/abstract-quote.component';
import {Store} from '@ngrx/store';

@Component({
    selector: 'app-quote-card',
    templateUrl: './quote-card.component.html',
    styleUrls: ['./quote-card.component.scss']
})
export class QuoteCardComponent extends AbstractQuoteComponent implements OnInit {
    readonly deleteQuoteMessageTextId = 'quote-card_delete-quote-confirmation-message';
    readonly viewQuoteMessageTextId = 'quote-card_view-quote-message';
    readonly downloadQuoteMessageTextId = 'quote-card_download-quote-message';
    quoteName: string;

    @Output()
    selectQuote = new EventEmitter<QuoteBarItem>();

    readonly quoteStateNew = QuoteState.NEW;

    constructor(protected dialog: MatDialog) {
        super();
    }

    ngOnInit() {
        if (this.quote.name.length > 18) {
            this.quoteName = `${this.quote.name.split("").splice(18).join("")}...`
        } else {
            this.quoteName = this.quote.name;
        }
    }

    onQuoteClick() {
        if (!this.isPending) {
            this.selectQuote.emit(this.quoteBarItem);
        }
    }
}
